import { theme } from 'antd';
import { ThemeConfigType } from './typing';

const colorBgContainer = '#2B2B2B';
const colorBgLayout = '#1F1F1F';
const colorTextBase = '#EDEDED';
const colorPrimary = '#1A73E8';
const colorSuccess = '#21BA45';
const colorWarning = '#F2C037';
const colorError = '#DB2828';
const colorInfo = '#31CCEC';

const themeId = 'dark-protanopia-and-deuteranopia';

export const darkProtanopiaAndDeuteranopiaTheme: ThemeConfigType = {
  id: themeId,
  type: 'dark',
  name: `themes.${themeId}`,
  previewImage: 'https://github.githubassets.com/assets/dark_colorblind_preview-f1cba27d7c61.svg',
  previewImageDisc: 'https://github.githubassets.com/assets/dark_colorblind_disc-cf4710564c71.svg',
  theme: {
    algorithm: [theme.darkAlgorithm],
    token: {
      blue: '#1A73E8',
      purple: '#6A0DAD',
      cyan: '#31CCEC',
      green: '#21BA45',
      magenta: '#DB2828',
      pink: '#FF69B4',
      red: '#DB2828',
      orange: '#F2711C',
      yellow: '#F2C037',
      volcano: '#FF6F61',
      geekblue: '#5A9BD4',
      gold: '#D4AF37',
      lime: '#32CD32',
      colorPrimary: colorPrimary,
      colorSuccess: colorSuccess,
      colorWarning: colorWarning,
      colorError: colorError,
      colorInfo: colorInfo,
      colorLink: colorPrimary,
      colorTextBase: colorTextBase,
      colorBgBase: colorBgContainer,
      lineWidth: 1,
      lineType: 'solid',
      borderRadius: 6,
      colorText: '#EDEDED',
      colorTextSecondary: '#C0C0C0',
      colorTextTertiary: '#A0A0A0',
      colorTextQuaternary: '#808080',
      colorFill: '#1F1F1F',
      colorFillSecondary: '#2B2B2B',
      colorFillTertiary: '#3B3B3B',
      colorFillQuaternary: '#4B4B4B',
      colorBgLayout: colorBgLayout,
      colorBgContainer: colorBgContainer,
      colorBgElevated: '#3B3B3B',
      colorBgSpotlight: '#464646',
      colorBgBlur: 'transparent',
      colorBorder: '#3B3B3B',
      colorBorderSecondary: '#4B4B4B',
      // colorPrimaryBg: '#2B2B2B',
      // colorPrimaryBgHover: '#1F1F1F',
      // colorPrimaryBorder: '#3B3B3B',
      // colorPrimaryBorderHover: '#4B4B4B',
      // colorPrimaryHover: '#2A52BE',
      // colorPrimaryActive: '#0047AB',
      // colorPrimaryTextHover: '#EDEDED',
      // colorPrimaryText: '#FFFFFF',
      // colorPrimaryTextActive: '#E0E0E0',
      colorSuccessBg: '#2B2B2B',
      colorSuccessBgHover: '#1F1F1F',
      colorSuccessBorder: '#3B3B3B',
      colorSuccessBorderHover: '#4B4B4B',
      colorSuccessHover: '#1A6A41',
      colorSuccessActive: '#004D33',
      colorSuccessTextHover: '#EDEDED',
      colorSuccessText: '#FFFFFF',
      colorSuccessTextActive: '#E0E0E0',
      colorErrorBg: '#2B2B2B',
      colorErrorBgHover: '#1F1F1F',
      colorErrorBgActive: '#4B2B2B',
      colorErrorBorder: '#3B3B3B',
      colorErrorBorderHover: '#4B4B4B',
      colorErrorHover: '#B22222',
      colorErrorActive: '#8B0000',
      colorErrorTextHover: '#EDEDED',
      colorErrorText: '#FFFFFF',
      colorErrorTextActive: '#E0E0E0',
      colorWarningBg: '#2B2B2B',
      colorWarningBgHover: '#1F1F1F',
      colorWarningBorder: '#3B3B3B',
      colorWarningBorderHover: '#4B4B4B',
      colorWarningHover: '#FFA500',
      colorWarningActive: '#FF8C00',
      colorWarningTextHover: '#EDEDED',
      colorWarningText: '#FFFFFF',
      colorWarningTextActive: '#E0E0E0',
      colorInfoBg: '#2B2B2B',
      colorInfoBgHover: '#1F1F1F',
      colorInfoBorder: '#3B3B3B',
      colorInfoBorderHover: '#4B4B4B',
      colorInfoHover: '#4682B4',
      colorInfoActive: '#4169E1',
      colorInfoTextHover: '#EDEDED',
      colorInfoText: '#FFFFFF',
      colorInfoTextActive: '#E0E0E0',
      colorLinkHover: '#1A73E8',
      colorLinkActive: '#1A73E8',
      colorBgMask: 'rgba(0, 0, 0, 0.5)',
      colorWhite: '#FFFFFF',
      lineWidthBold: 2,
      colorFillContent: 'rgba(0, 0, 0, 0.1)',
      colorFillContentHover: 'rgba(0, 0, 0, 0.2)',
      colorFillAlter: 'rgba(0, 0, 0, 0.3)',
      colorBgContainerDisabled: 'rgba(0, 0, 0, 0.5)',
      colorBorderBg: '#3B3B3B',
      colorSplit: 'rgba(0, 0, 0, 0.3)',
      colorTextPlaceholder: 'rgba(255, 255, 255, 0.5)',
      colorTextDisabled: 'rgba(255, 255, 255, 0.3)',
      colorTextHeading: '#EDEDED',
      colorTextLabel: '#C0C0C0',
      colorTextDescription: '#A0A0A0',
      colorTextLightSolid: '#FFFFFF',
      colorHighlight: '#1A73E8',
      colorBgTextHover: 'rgba(0, 0, 0, 0.1)',
      colorBgTextActive: 'rgba(0, 0, 0, 0.2)',
      colorIcon: 'rgba(255, 255, 255, 0.8)',
      colorIconHover: 'rgba(255, 255, 255, 1)',
      colorErrorOutline: 'rgba(255, 0, 0, 0.8)',
      colorWarningOutline: 'rgba(255, 165, 0, 0.8)',
      controlItemBgHover: 'rgba(255, 255, 255, 0.1)',
      controlItemBgActive: '#0047AB',
      controlItemBgActiveHover: '#2A52BE',
      controlItemBgActiveDisabled: 'rgba(255, 255, 255, 0.5)',
      controlTmpOutline: 'rgba(255, 255, 255, 0.5)',
      controlOutline: 'rgba(255, 255, 255, 0.5)',
      linkDecoration: 'none',
      linkHoverDecoration: 'none',
      linkFocusDecoration: 'none',
      boxShadow: `
        0 6px 16px 0 rgba(0, 0, 0, 0.5),
        0 3px 6px -4px rgba(0, 0, 0, 0.3),
        0 9px 28px 8px rgba(0, 0, 0, 0.2)
      `,
      boxShadowSecondary: `
        0 6px 16px 0 rgba(0, 0, 0, 0.5),
        0 3px 6px -4px rgba(0, 0, 0, 0.3),
        0 9px 28px 8px rgba(0, 0, 0, 0.2)
      `,
      boxShadowTertiary: `
        0 1px 2px 0 rgba(0, 0, 0, 0.5),
        0 1px 6px -1px rgba(0, 0, 0, 0.3),
        0 2px 4px 0 rgba(0, 0, 0, 0.2)
      `,
    },
  },
  layout: {
    hashId: themeId,
    colorPrimary: colorPrimary,
    colorTextAppListIcon: 'rgba(255, 255, 255, 0.8)',
    colorBgAppListIconHover: 'rgba(255, 255, 255, 0.1)',
    colorTextAppListIconHover: 'rgba(255, 255, 255, 1)',
    bgLayout: `linear-gradient(${colorBgContainer}, ${colorBgLayout} 28%)`,
    sider: {
      paddingInlineLayoutMenu: 8,
      paddingBlockLayoutMenu: 0,
      colorBgCollapsedButton: '#2A52BE',
      colorTextCollapsedButtonHover: 'rgba(255, 255, 255, 0.8)',
      colorTextCollapsedButton: 'rgba(255, 255, 255, 0.6)',
      colorMenuBackground: 'transparent',
      colorMenuItemDivider: 'rgba(255, 255, 255, 0.1)',
      colorBgMenuItemHover: 'rgba(0, 0, 0, 0.1)',
      colorBgMenuItemSelected: 'rgba(0, 0, 0, 0.2)',
      colorTextMenuItemHover: 'rgba(255, 255, 255, 1)',
      colorTextMenuSelected: 'rgba(255, 255, 255, 0.8)',
      colorTextMenuActive: 'rgba(255, 255, 255, 1)',
      colorTextMenu: 'rgba(255, 255, 255, 0.8)',
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.6)',
      colorTextMenuTitle: 'rgba(255, 255, 255, 1)',
      colorTextSubMenuSelected: 'rgba(255, 255, 255, 1)',
      colorBgMenuItemActive: 'rgba(0, 0, 0, 0.2)',
      colorBgMenuItemCollapsedElevated: 'transparent'
    },
    header: {
      colorBgHeader: 'rgba(0, 0, 0, 0.8)',
      colorBgScrollHeader: 'rgba(0, 0, 0, 0.6)',
      colorHeaderTitle: 'rgba(255, 255, 255, 1)',
      colorBgMenuItemHover: 'rgba(0, 0, 0, 0.2)',
      colorBgMenuItemSelected: 'transparent',
      colorTextMenuSelected: 'rgba(255, 255, 255, 0.8)',
      colorBgRightActionsItemHover: 'rgba(0, 0, 0, 0.1)',
      colorTextRightActionsItem: 'rgba(255, 255, 255, 0.8)',
      heightLayoutHeader: 56,
      colorTextMenu: 'rgba(255, 255, 255, 0.8)',
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.6)',
      colorTextMenuActive: 'rgba(255, 255, 255, 1)',
      colorBgMenuElevated: 'rgba(0, 0, 0, 0.3)',
    },
    pageContainer: {
      colorBgPageContainer: 'transparent',
      paddingInlinePageContainerContent: 40,
      paddingBlockPageContainerContent: 32,
      colorBgPageContainerFixed: '#1F1F1F',
    },
  },
};
